export default "__VITE_ASSET__DkN_k29r__"